import React, {Fragment} from 'react';
import {Row, Col} from 'reactstrap';

import './MovieCard.scss'
import {imgUrl} from '../../utils/api-request';

const statusIcons = {
    draft: 'fa-pencil-alt',
    published: 'fa-check',
}

const MovieCard = ({ movie, hideStatus = false }) => {
    const hasPoster = movie.poster?.imageUrl;
    const hasYoutubeTrailer = movie.youtubeTrailerId && movie.youtubeTrailerId.trim() !== '';
    const audioLanguages = movie.audioLanguages && movie.audioLanguages.length > 0
        ? movie.audioLanguages.join(', ').toUpperCase()
        : 'N/A';
    const subtitleLanguages = movie.subtitleLanguages && movie.subtitleLanguages.length > 0
        ? movie.subtitleLanguages.join(', ').toUpperCase()
        : 'N/A';

    const versionText = movie.versionsCount === 0 ? '0 versions' : movie.versionsCount === 1 ? '1 version' : `${movie.versionsCount} versions`;

    const metadata = (
        <Fragment>
            <div className="order-credits m-2 ms-0 d-inline-flex align-items-center small">
                <span className="fas fa-fw fa-film me-2 text-primary"/>
                {versionText}
            </div>
            <div className="order-credits m-2 d-inline-flex align-items-center small">
                <span className="fas fa-fw fa-volume-up me-2 text-primary"/>
                {audioLanguages}
            </div>
            <div className="order-credits m-2 d-inline-flex align-items-center small">
                <span className="fas fa-fw fa-closed-captioning me-2 text-primary"/>
                {subtitleLanguages}
            </div>
            {movie.trailerVersionsCount > 0 && (
                <div className="order-credits m-2 d-inline-flex align-items-center small">
                    <span className="fas fa-fw fa-film-simple me-2 text-primary"/>
                    DCP Trailers: {movie.trailerVersionsCount}
                </div>
            )}
            {hasYoutubeTrailer && (
                <div className="order-credits m-2 d-inline-flex align-items-center">
                    <span className="fab fa-fw fa-youtube text-danger"/>
                </div>
            )}
        </Fragment>
    );

    return (
        <Row className="movie-card-component py-3 mx-0 my-3 d-flex">
            <Col xs="auto">
                {hasPoster ? (
                    <img
                        className="logo-img"
                        width={75}
                        alt={movie.title}
                        src={imgUrl(movie.poster.imageUrl)}
                    />
                ) : (
                    <div className="logo-img-placeholder d-flex align-items-center justify-content-center">
                        <span className="movie-title-text text-center px-1">{movie.title}</span>
                    </div>
                )}
            </Col>
            <Col>
                <div>
                    <div className="title text-uppercase text-primary d-flex flex-column flex-lg-row align-items-lg-center">
                        <div className="flex-grow-1">
                            {movie.title}
                        </div>
                        {movie.releaseYear && (
                            <span className="badge bg-primary text-black me-2 ms-2 my-1">
                                {movie.releaseYear}
                            </span>
                        )}
                        {!hideStatus && (
                            <span className="status d-flex align-items-center ps-2 pe-3 my-1">
                                <span className={`fas fa-fw ${statusIcons[movie.status]} me-2 ${movie.status === 'published' ? 'text-success' : 'text-danger'}`}/>
                                {movie.status}
                            </span>
                        )}
                    </div>
                </div>

                {movie.genres && movie.genres.length > 0 && (
                    <div className="genres mt-2 d-flex flex-wrap gap-2 small">
                        {movie.genres.map((genre, idx) => (
                            <span key={idx} className="badge bg-primary bg-opacity-25 text-white text-uppercase" style={{ fontSize: '10px' }}>
                                {genre}
                            </span>
                        ))}
                    </div>
                )}

                <div className="mt-3 d-flex flex-wrap">
                    {metadata}
                </div>
            </Col>
        </Row>
    );
};

export default MovieCard;
